export const apibaseurl = "https://nestfin.app:8443"
// export const apibaseurl = "http://nestfin.app:9090/"
// export const apibaseurl = "https://weconnect.bizclockinfotech.com:9090"
export const localHostUrl = "http://localhost:3000/"
export const jwttoken = localStorage.getItem("token")
export const login = "/api/leads/v1/login";
export const verifyOtp = "/api/leads/v1/verify-otp";
export const localityUrl = "/api/leads/v1/get-pref-localities";
export const viewLeadProfile = "/api/leads/v1/view-lead-profile";
export const fetchPropertyByFilters = "/api/leads/v1/fetch-property-by-filters";
export const getPropertyById = "/api/leads/v1/get-property-by-id"
export const getRoomOptionsById = "/api/leads/v1/get-room-options-by-id"
export const propertyTanantAdd = "/api/tanant/v1/property-tanant-add"
export const propertyTanantBooking = "/api/tanant/v1/property-tanant-booking"
export const propertyTanantAgreementDetails = "/api/tanant/v1/property-tanant-agreement-details"
export const updateLeadProfile = "/api/leads/v1/update-lead-profile"
export const getBookingsByTenant = "/api/tanant/v1/get-bookings-by-tenant"



